import React, { Component } from 'react';
import { Button, Modal, Radio, Checkbox, message } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { KYC_USER_ICON, KYC_PLUGIN_ICON } from '../../config/media';
import Wrapper, { ModelWrapper } from './style';
import { downloadPlugin, getActivation, getExchange, requestPlugins } from '../../common/fetch';
import { ExchangeAction } from '../../actions';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'

const radioStyle = {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    lineHeight: '1.2',
    padding: '24px 0',
    margin: 0,
    paddingLeft: '1px',
    whiteSpace: 'normal',
    letterSpacing: '-0.15px',
};

class Kyc extends Component {
    constructor() {
        super()
        this.state = {
            isVisible: false,
            type: '',
            userAmount: 'low',
            is_checked: false,
            activationData: {},
            userCount: 0,
            plugins: [],
            pluginData: {}
        }
    }

    componentDidMount() {
        const { exchange } =  this.props;
        this.getActivation();
        this.getAllPlugins();
        this.getExchange();
        if (exchange && exchange.kyc_quota) {
            this.setState({ userCount: exchange.kyc_quota });
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.exchange) !== JSON.stringify(this.props.exchange)
        ) {
            this.setState({ userCount: this.props.exchange.kyc_quota });
        }
    }

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            this.props.actions.readData(exchange);
        } catch (error) {
            console.error(error);
        }
    };

    getActivation = async () => {
        try {
            const res = await getActivation('automatic-kyc');
            this.setState({
                activationData: res.data,
            });
        } catch (error) {}
    };

    getAllPlugins = async () => {
        try {
            const res = await requestPlugins();
            if (res.data) {
                const plugins = res.data.data;
                this.setState({ plugins });
            }
        } catch (error) {
            message.error(error.data.message);
        }
    };

    toggleVisibility = (isVisible, type) => {
        this.setState({ isVisible, type });
    }

    handleSelectChange = (userAmount) => {
        this.setState({ userAmount });
    }

    handleCheck = (e) => {
        this.setState({ is_checked: e.target.checked });
    }

    handleRedirect = () => {
        this.setState({ isVisible: false });
        let userCount;
        if (this.state.userAmount && this.state.userAmount === 'high') {
            userCount = 'automatic-kyc5000';
        } else if (this.state.userAmount && this.state.userAmount === 'medium') {
            userCount = 'automatic-kyc1000';
        } else {
            userCount = 'automatic-kyc100';
        }
        this.props.history.push(`/billing?isPayment=true&currentTab=payment&type=cryptoCurrency&invoiceData=${userCount}`);
    }

    handleDownload = async () => {
        let pluginName = '';
        this.state.plugins.forEach(data => {
            if (data.premium) {
                pluginName = data.name;
            }
        });
        try {
            const res = await downloadPlugin(pluginName);
            if (res.data) {
                this.setState({ pluginData: res.data });
                this.toggleVisibility(false, '');
                message.success('Downloaded successfully');
            }
        } catch (error) {
            message.error(error.data.message);
        }
    };

    handleBack = (type) => {
        this.setState({ type });
    };

    renderPopupContent = () => {
        const url = 'https://docs.hollaex.com/how-tos/develop-plugins/installing-plugin';
        switch (this.state.type) {
            case 'charge':
                return (
                    <ModelWrapper>
                        <div>
                            <div className="warning-wrapper">
                                <img className="kyc-icon" src={KYC_PLUGIN_ICON} alt={"KYC_PLUGIN_ICON"} />
                                <div className="divider"></div>
                                <div className="inner-content">
                                    <div className="title">
                                        Charge automated KYC and AML
                                    </div>
                                    <div>
                                        Charge your user verifications on a pay as you go bases.
                                    </div>
                                </div>
                            </div>
                            <div className="sub-title mt-2">Select amount of user verifications:</div>
                            <div>
                                <Radio.Group
                                    name="amountOfUser"
                                    value={this.state.userAmount}
                                    onChange={(e) => {
                                        this.handleSelectChange(e.target.value)
                                    }}
                                    className="user-amount-selector"
                                >
                                    <Radio style={radioStyle} value={'low'}>
                                        <div className="options">
                                            <div>100 users</div>
                                            <div>$300</div>
                                        </div>
                                    </Radio>
                                    <Radio style={radioStyle} value={'medium'}>
                                        <div className="options">
                                            <div>1,000 users</div>
                                            <div>$2,800 <span>(6% OFF)</span></div>
                                        </div>
                                    </Radio>
                                    <Radio style={radioStyle} value={'high'}>
                                        <div className="options">
                                            <div>5,000 users</div>
                                            <div>$13,000 <span>(13% OFF)</span></div>
                                        </div>
                                    </Radio>
                                </Radio.Group>
                            </div>
                            <div className="button-wrapper">
                                <Button
                                    type="primary"
                                    onClick={this.handleRedirect}
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            case 'activate':
                return (
                    <ModelWrapper>
                        <div>
                            <div className="title">
                                Activate automated KYC and AML
                            </div>
                            <div>
                            </div>
                            <div className="warning-wrapper">
                                <img className="kyc-icon" src={KYC_PLUGIN_ICON} alt={"KYC_PLUGIN_ICON"} />
                                <div className="divider"></div>
                                <div className="inner-content">
                                    <div className="sub-title">One time plugin activation cost:</div>
                                    <div className="cost-section">
                                        <div>Activation costs:</div>
                                        <div className="sub-title">$1,500</div>
                                    </div>
                                </div>
                            </div>
                            <div className="seperator"></div>
                            <div className="sub-title">Select amount of user verifications:</div>
                            <div>
                                <Radio.Group
                                    name="amountOfUser"
                                    value={this.state.userAmount}
                                    onChange={(e) => {
                                        this.handleSelectChange(e.target.value)
                                    }}
                                    className="user-amount-selector"
                                >
                                    <Radio style={radioStyle} value={'low'}>
                                        <div className="options">
                                            <div>100 users</div>
                                            <div>$300</div>
                                        </div>
                                    </Radio>
                                    <Radio style={radioStyle} value={'medium'}>
                                        <div className="options">
                                            <div>1,000 users</div>
                                            <div>$2,800 <span>(6% OFF)</span></div>
                                        </div>
                                    </Radio>
                                    <Radio style={radioStyle} value={'high'}>
                                        <div className="options">
                                            <div>5,000 users</div>
                                            <div>$13,000 <span>(13% OFF)</span></div>
                                        </div>
                                    </Radio>
                                </Radio.Group>
                            </div>
                            <div className="button-wrapper">
                                <Button
                                    type="primary"
                                    onClick={() => this.toggleVisibility(true, 'terms-of-use')}
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            case 'terms-of-use':
                return (
                    <ModelWrapper>
                        <div>
                            <div className="title">
                                Terms of use
                            </div>
                            <div className="text-area">
                                <div>
                                    Terms of use agreement.
                                </div>
                                <div>
                                   By activating this plugin, I hereby understand that Automatic KYC plugin is offered by Idenfy (https://www.idenfy.com) which is a third party company and I have read and accept all the terms of services using the third party services. 
                                </div>
                                <div>
                                    I understand that HollaEx or its affiliates as we as Idenfy might require to have access to my information and those using my website for purposes of providing the service. I hereby take all actions required to keep and store my user's information safe and secure required by the law and regulation and will maintain the information private. I also understand that HollaEx and its affiliates would NOT be liable for any issues arising from AML/KYC checks done through Idenfy and you must always double check to ensure the accuracy of the data and information provided.
                                </div>
                                <div>
                                    All the fees involved in order to activate and use this plugin are not refundable and you are required to activate and pre purchase credits for making verification checks.
                                </div>
                                
                            </div>
                        </div>
                        <Checkbox
                            name="is_terms"
                            onChange={this.handleCheck}
                            checked={this.state.is_checked}
                            className="sub-txt"
                        >
                            Yes, I have read and agree to the terms
                        </Checkbox>
                        <div className="button-wrapper btn-align">
                            <Button
                                type="primary"
                                onClick={() => this.handleBack('activate')}
                            >
                                Back
                            </Button>
                            <Button
                                type="primary"
                                disabled={!this.state.is_checked}
                                onClick={this.handleRedirect}
                            >
                                Next
                            </Button>
                        </div>
                    </ModelWrapper>
                );
            case 'download-plugin':
                return (
                    <ModelWrapper>
                        <div>
                            <div className="title">
                                Download plugin
                            </div>
                            <div className="warning-wrapper">
                                <img className="kyc-icon" src={KYC_PLUGIN_ICON} alt={"KYC_PLUGIN_ICON"} />
                                <div className="divider"></div>
                                To activate the automated KYC and AML system for your exchange you must download the JSON and install it.
                            </div>
                            <div className='description-content'>
                                <div className="content-title">
                                    Follow the step below:
                                </div>
                                <div>
                                    1.  Download JSON below
                                </div>
                                <div>
                                    2.  Click 'ADD THIRD PARTY PLUGIN' button in your plugins Operator Control Panel
                                </div>
                                <div>
                                    3.  Upload the downloaded JSON file and confirm
                                </div>
                            </div>
                            <div className="content-wrapper">
                                To read more about plugins follow the link below::
                            </div>
                            <a target="blank" href={`${url}`}>{url}</a>
                            <div className="button-wrapper">
                                <Button
                                    type="primary"
                                    onClick={this.handleDownload}
                                >
                                    Download
                                </Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            default:
                return <div />
        }
    };
    renderTextColor = () => {
        const { userCount } = this.state;
        if (userCount > 0) {
            return "font-green"
        } else if (userCount < 0) {
            return "font-red"
        } else {
            return ""
        }
    };

    renderCard = () => {
        let textClass = this.renderTextColor();
        const { userCount, activationData } = this.state;
        return (
            <div className="box-wrapper">
                <div className="box-container">
                    <div className="d-flex">
                        <div className="cloud-icon">
                            <img src={KYC_USER_ICON} alt="KYC_USER_ICON" />
                        </div>
                        <div className="box-text-wrapper">
                            <div className="content-title">
                                User Verification lefts
                            </div>
                            {userCount < 0
                                ?
                                <div className="warning-wrapper">
                                    <div className="small-round warning"></div>
                                    <div className={textClass}>
                                        <span>{userCount}</span>{" "}users
                                    </div>
                                </div>
                                :
                                <div className={textClass}>
                                    <span>{userCount}</span>{" "}users
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="btn-wrapper rounded-btn">
                    <Link to="/billing?tab=2">View last bill</Link>
                    {activationData.is_active
                        ?
                        <Button
                            type='primary'
                            onClick={() => this.toggleVisibility(true, 'charge')}
                        >
                            Charge
                        </Button>
                        :
                        <Button
                            type='primary'
                            onClick={() => this.toggleVisibility(true, 'activate')}
                        >
                            Activate
                        </Button>
                    }
                </div>
            </div>
        )
    }

    renderInformation = () => {
        const { userCount, activationData } = this.state;
        if (userCount < 0) {
            return <div className="font-red warn-text">
                If you see your users verifications as a negative value it means you've have reached the limit of your verifications and that you should <Link to=''>charge</Link> to continue using the automated KYC system.
            </div>
        } else if (userCount === 0 || activationData.is_active) {
            return <div className="warn-text">
                Note, as two active KYC plugins will not work you must first remove the manual KYC plugin in order to activate the automated KYC.
            </div>
        }
    }
    
    render() {
        const { activationData, isVisible, userCount } = this.state;
        return (
            <Wrapper>
                <div className="main-header">Know your customer (KYC)</div>
                <div className={`content ${this.props.constant.isExchangeExpired ? "expired-status" : ""}`}>
                    <div className="flex-center box">
                        <div className="KYC_PLUGIN_ICON">
                            <img src={KYC_PLUGIN_ICON} alt="KYC_PLUGIN_ICON" />
                        </div>
                        <div className="divider" />
                        <div>
                            <div>
                                Activate an automated KYC and AML plugin that will streamline your user on boarding and verification.
                            </div>
                            <div>
                                First pay for a one time setup and activation and then pay as you go for as many user verification as you need.
                            </div>
                            <div className="divider" />
                            <div className={!activationData.is_active ? "disabled-btn rounded-btn" : "rounded-btn"}>
                                <Button
                                    type='primary'
                                    onClick={() => {
                                        if (!activationData.is_active) {
                                            message.error("To download the plugin you must activate it first");
                                        } else {
                                            this.setState({ isVisible: true, type: 'download-plugin' });
                                        }
                                    }}
                                >
                                    Download Plugin
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        {this.renderCard()}
                        {!activationData.is_active
                            ? 
                            <div className="warning-wrapper">
                                {userCount === 0
                                    ? <div className="small-round"></div>
                                    : (userCount < 0
                                        ? <div className="small-round warning"></div>
                                        : null
                                    )
                                }
                                {this.renderInformation()}
                            </div>
                            : null
                        }
                    </div>
                </div>
                {this.props.constant.isExchangeExpired && <ExchangeTerminateMessage />}
                <Modal
                    visible={isVisible}
                    onCancel={() => this.toggleVisibility(false)}
                    footer={null}
                    width={500}
                >
                    {this.renderPopupContent()}
                </Modal>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
    constant: state.constant,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ExchangeAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Kyc);